import CustomerIndex from '@/views/Customer/Index.vue'
import HomeView from '@/views/Customer/HomeView.vue'
import AboutView from '@/views/Customer/AboutView.vue'
import FaqView from '@/views/Customer/FaqView.vue'
import FeaturesView from '@/views/Customer/FeaturesView.vue'
import ImprintView from '@/views/Customer/ImprintView.vue'
import DataProtectionView from '@/views/Customer/DataProtectionView.vue'
import PartnerSearchView from '@/views/Customer/PartnerSearchView.vue'

export const defaultMeta = {
  title: 'Cloud-Telefonanlage mit System – AGFEO HyperFonie ab 6,90 €/Monat',
  description: 'Flexibel skalierbare Cloud-Telefonanlage (ab 3 Nutzern), hosting in Bielefeld, TÜV-zertifiziert, DSGVO-konform & Funktions-FLAT – jetzt ab 6,90 €/Monat.',
}

export default {
  path: '/',
  name: 'customer',
  component: CustomerIndex,
  redirect: { name: 'home' },
  children: [
    {
      path: 'start',
      name: 'home',
      component: HomeView,
      meta: defaultMeta,
    },
    {
      path: 'about',
      name: 'about',
      component: AboutView,
      meta: {
        title: 'Über Hyperfonie – Die AGFEO Cloud-Telefonanlage aus Deutschland',
        description: 'Erfahre, wer hinter Hyperfonie steckt: 75 Jahre AGFEO-Kompetenz, deutsches Hosting, Innovation & persönliche Nähe für deine Business-Kommunikation.',
      },
    },
    {
      path: 'features',
      name: 'features',
      component: FeaturesView,
      meta: {
        title: 'Funktionen der Hyperfonie – Alle Features der Cloud-Telefonanlage im Überblick',
        description: 'Entdecke die umfassenden Features der AGFEO Hyperfonie: CTI/UC, Integration mit MS Teams, CRM, Rechenzentrum in Deutschland & vieles mehr.',
      },
    },
    {
      path: 'faq',
      name: 'faq',
      component: FaqView,
      meta: {
        title: 'Hyperfonie FAQ – Antworten zur Cloud-Telefonie, Preisen & Technik',
        description: 'Hier findest du Antworten auf häufige Fragen zur AGFEO Hyperfonie: Tarife, Technik, Vertragslaufzeiten, Support & Konfiguration.',
      },
    },
    {
      path: 'impressum',
      name: 'imprint',
      component: ImprintView,
    },
    {
      path: 'datenschutz',
      name: 'data-protection',
      component: DataProtectionView,
    },
    {
      path: 'fachhaendler-suche',
      name: 'partner-search',
      component: PartnerSearchView,
    },
  ]
}
